function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h12v12H0z"
}), React.createElement("g", {
  stroke: "#595959",
  strokeWidth: 0.923
}, React.createElement("path", {
  d: "M5.465 1.616L1.749 5.357 1.543 6h3.95a.462.462 0 0 0 .462-.462V1.501l-.49.115z"
}), React.createElement("path", {
  d: "M3.519 3.572L1.512 5.596a.462.462 0 0 0-.134.325v5.156c0 .255.207.461.462.461h8.237a.462.462 0 0 0 .461-.461v-9.23a.462.462 0 0 0-.461-.462H5.883c-.123 0-.24.049-.327.136L3.519 3.572z"
})));

var SvgIcWork = function SvgIcWork(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcWork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-work.5b1cb9e7.svg";
export { ForwardRef as ReactComponent };